<template>
  <v-icon v-if="value" color="success" small v-on="$listeners">check_circle_outline</v-icon>
  <v-icon v-else color="error" small v-on="$listeners">highlight_off</v-icon>
</template>

<script>
export default {
  name: 'TickOrCross',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
